import { FC } from "react";
import { FormWrapper, FormTitle } from "./components/MonolithFormComponents";
import { usePermissions } from "@/hooks/usePermissions";
import { useSnackbar, VariantType } from "notistack";
import LoggingAPI from "@/api/logging";
import DefaultGroupForm, { defaultGroupData } from "./DefaultGroupForm";
import UserGroupsAPI from "@/api/users/groups";
import { nanoid } from "nanoid";

interface CreateGroupFormProps {
  width?: number | undefined;
  onSubmit: () => void;
  onCancel: () => void;
}

const CreateGroupForm: FC<CreateGroupFormProps> = ({
  width,
  onSubmit,
  onCancel,
}) => {
  const { currentUser } = usePermissions();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (data: defaultGroupData) => {
    try {
      await UserGroupsAPI.create({
        ...data,
        created_on: new Date().toISOString(),
        created_by_id: currentUser?.uuid || currentUser?.user_id,
        uuid: nanoid(),
      });

      onSubmit?.();
      enqueueSnackbar(`${data?.name || ""} group created`, {
        variant: "success" as VariantType,
      });

      LoggingAPI.createLog({
        user_id: currentUser.user_id,
        message: `Created User Group: ${data?.name}`,
        event: "group:create",
        object_type: "user_group",
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        "An error occurred while creating this User Group. Please try again.",
        { variant: "error" as VariantType }
      );
    }
  };

  return (
    <FormWrapper width={width}>
      <FormTitle>Create User Group</FormTitle>
      <DefaultGroupForm
        onSubmit={handleSubmit}
        onCancel={onCancel}
        buttonProps={{ submitText: "Create Group" }}
      />
    </FormWrapper>
  );
};
export default CreateGroupForm;
